export function formatMoney(minor: number, currency = "GBP"): string {
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency
  }).format((minor ?? 0) / 100);
}

export function formatDateTime(value: string): string {
  if (!value.trim()) {
    return "Time TBD";
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return value;
  }

  return new Intl.DateTimeFormat("en-GB", {
    dateStyle: "medium",
    timeStyle: "short"
  }).format(parsed);
}
